// Many of these functions are deprecated. Use https://github.com/derek-watson/jsUri methods instead.
// That library is also unmaintained, so maybe we should find something new

/**********************
 * These functions are duplicated by adapters/dupes/queryParams.js
 * If you edit them, do it in both places
 **********************/
window.getQueryStringParams = function (query) {
    // noinspection DuplicatedCode
    if (query == null) return {};

    // new Uri(query) expects a full URL string, however the original version of getQueryStringParams
    // expected the query string after ? only -- to fix, check for ? and = and add back uri if necessary
    if (query.indexOf('=') > -1 && query.indexOf('?') === -1) {
        query = '?' + query;
    }

    const uri = new Uri(query);
    const params = {};
    uri.queryPairs.forEach(function (pair) {
        const key = pair[0];
        const val = pair[1];
        const currentValue = params[key];
        if (currentValue == null) {
            params[key] = val;
        } else if (Array.isArray(currentValue)) {
            currentValue.push(val);
        } else {
            params[key] = [currentValue, val];
        }
    });

    return params;
};

window.getURLParams = function (fullURL) {
    return window.getQueryStringParams(fullURL);
};

window.getURLParam = function (fullURL, param) {
    const queryParams = window.getURLParams(fullURL);
    return queryParams[param];
};
/**********************
 * END duplicated functions
 * If you edit them, do it in both places
 **********************/

window.getQueryStringParamsBasedOnSplit = function (query) {
    const param = {};
    if (query == null) return param;
    if (query.indexOf('?') > -1) query = query.split('?')[1];
    const params = query.split('&');
    for (let i = 0; i < params.length; i++) {
        const pos = params[i].indexOf('=');
        if (pos > 0) {
            const key = params[i].substring(0, pos);
            param[key] = params[i].substring(pos + 1);
        }
    }
    return param;
};

/**
 *  Note that an array is returned when two or more params with the same name are on the query string
 */
window.getQueryStringParam = function (query, param) {
    return window.getQueryStringParams(query)[param];
};

/**
 *  qsParam is restricted to single values
 */
window.qsParam = null;
if (window.location) {
    window.qsParam = window.getQueryStringParamsBasedOnSplit(window.location.search.slice(1));
}

/**
 * @deprecated
 * URL manipulation should be done with Uri.js
 */
window.setQueryStringParam = function (query, param, newValue) {
    const currentParams = window.getQueryStringParams(query, '&');
    const currentValue = (currentParams != null) ? currentParams[param] : null;
    if (currentValue == null) return query + ((query != '') ? '&' : '') + param + '=' + newValue;
    else return query.replace(param + '=' + currentValue, param + '=' + newValue);
};

/**
 * @deprecated
 * URL manipulation should be done with Uri.js
 * Only used by setURLParam
 */
function removeQueryStringParam(query, param) {
    const prefix = encodeURIComponent(param) + '=';
    const pars = query.split(/[&;]/g);
    for (let i = pars.length; i-- > 0;) {
        if (pars[i].indexOf(prefix) === 0) {
            pars.splice(i, 1);
        }
    }
    if (pars.length > 0) return pars.join('&');
    else return '';
}

/**
 * @deprecated
 * URL manipulation should be done with Uri.js.
 * This won't work for multi-valued parameters
 */
window.setURLParam = function (fullURL, param, newValue) {
    let uri = fullURL;
    let query = '';
    let hash = '';
    if (uri.indexOf('#') > -1) {
        const uriArray = uri.split('#');
        uri = uriArray[0];
        hash = uriArray[1];
    }
    if (uri.indexOf('?') > -1) {
        const uriArray = uri.split('?');
        uri = uriArray[0];
        query = uriArray[1];
    }
    if (param != null && newValue != null) query = window.setQueryStringParam(query, param, newValue);
    else if (param != null) query = removeQueryStringParam(query, param);
    return uri + ((query != null && query.length > 0) ? '?' + query : '') + ((hash != null && hash.length > 0) ? '#' + hash : '');
};

// TODO: Update this to use URI.js. It's too much work right now
window.getTrackingLink = function (fullURL, campaign, pageSource) {
    pageSource = pageSource || pageName;
    if (typeof pageSource === 'undefined') {
        // pageName is set to the jsp name elsewhere, but in case that doesn't happen we are still providing a default
        pageSource = 'unknown_page';
    }

    pageSource = pageSource.replace(/\s/g, '');
    campaign = campaign.replace(/\s/g, '_');

    const urlObj = new Uri(fullURL);

    urlObj.replaceQueryParam('utm_source', 'dc');
    urlObj.replaceQueryParam('utm_medium', campaign);
    urlObj.replaceQueryParam('utm_campaign', pageSource.toLowerCase());
    if (window.isNonBlankCookie('userId') && window.userId) {
        if (typeof teacherId !== 'undefined' && parseInt(window.teacherId) === parseInt(window.userId)) {
            urlObj.replaceQueryParam('utm_term', 'teacher_' + window.userId);
        } else {
            urlObj.replaceQueryParam('utm_term', 'donor_' + window.userId);
        }
    } else {
        urlObj.replaceQueryParam('utm_term', 'unknown');
    }

    return encodeURIComponent(window.setDefaultRFParamOnURL(urlObj.toString(), campaign, pageSource));
};

window.getParameterByName = function (name) {
    name = name.replace(/\[/, '\\[').replace(/]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
